import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Grid } from "@/comn/components";
import { comnUtils, comnEnvs } from "@/comn/utils"; // 프로젝트 공통 유틸
import { Page, Group, Layout, Button, FormControl } from "@/comn/components"; // 화면 구성 컴포넌트
import {
    useForm,
    useAuth,
    useFetch,
    useResource,
    useGrid,
    useModal,
    useStore,
    useToast,
    usePopup,
    usePage,
} from "@/comn/hooks"; // hook
import {
    BASE,
    URLS,
    APIS,
    BTCH_EXECUTION_HOUR_OPTIONS,
    SF_BTCH_SCHD_FORM,
    SG_BTCH_SCHD_PRMT_LIST,
} from "@/tz/go/egaz/osci/ptl/btch/schd/services/OsciBtchSchdMgmtService";

/*
 * Manage schedules details
 * !== 스케줄관리 상세 ==!
 */
export const OSCI0112007S = (props: any) => {
    /*
     * Declaration Hook, Meta
     * !== Hook, 메타 정보 정의 ==!
     */
    const { pgeUid, menuId } = usePage({
        auth: ["auth_osci0003"],
    });
    const { t } = useTranslation(); // Translation Hook !== 언어 변화 Hook ==!
    const navigate = useNavigate(); // Navigate Hook !== 화면 이동 Hook ==!
    const { btchSchdId } = useParams();
    const modal = useModal(); // Modal Window Hook !== Modal 창 Hook ==!
    const { pgeStore, setStore } = useStore({ pgeUid: pgeUid }); // Page Store Hook !== 화면 데이터 저장 Hook ==!
    const toast = useToast(); // Toast Message Hook !== Toast 메세지 표시 Hook ==!
    const auth = useAuth(); // Login , User Information Hook !== 로그인, 유저정보 Hook ==!

    // Change execution cycle select !== 실행주기 select 변경 ==!
    const [btchCycleTp, setBtchCycleTp] = useState();

    /*
     * Declaration Form
     * !== 폼 정의 ==!
     */
    const form = {
        // Manage schedules Form !== 스케줄관리 Form ==!
        btchInfoForm: useForm({
            defaultSchema: SF_BTCH_SCHD_FORM,
            defaultValues: {
                ...(pgeStore?.form || {}),
            },
        }),
    };

    /*
     * Declaration Grid
     * !== 그리드 정의 ==!
     */
    const grid = {
        btchSchdPrmtList: useGrid({
            defaultSchema: SG_BTCH_SCHD_PRMT_LIST,
            page: pgeStore?.page,
            size: pgeStore?.size,
        }),
    };

    /* Batch Execution Time !== 시간 ==!*/
    const excutnSchdTime = BTCH_EXECUTION_HOUR_OPTIONS;

    /* Batch Execution Minit !== 분 ==!*/
    const excutnSchdMi = [
        { label: "00", value: "00" },
        { label: "10", value: "10" },
        { label: "20", value: "20" },
        { label: "30", value: "30" },
        { label: "40", value: "40" },
        { label: "50", value: "50" },
    ];

    /* Batch Execution Second !== 초 ==!*/
    const excutnSchdSs = [
        { label: "00", value: "00" },
        { label: "05", value: "05" },
        { label: "10", value: "10" },
        { label: "15", value: "15" },
        { label: "20", value: "20" },
        { label: "25", value: "25" },
        { label: "30", value: "30" },
        { label: "35", value: "35" },
        { label: "40", value: "40" },
        { label: "45", value: "45" },
        { label: "50", value: "50" },
        { label: "55", value: "55" },
    ];

    /* Batch Execution Day of Week !== 요일 ==!*/
    const btchExcutnDwk = [
        { label: "L_SUN", value: "SUN" },
        { label: "L_MON", value: "MON" },
        { label: "L_TUE", value: "TUE" },
        { label: "L_WED", value: "WED" },
        { label: "L_THU", value: "THU" },
        { label: "L_FRI", value: "FRI" },
        { label: "L_SAT", value: "SAT" },
    ];

    /* Batch Execution Day of Week !== 요일 ==!*/
    const excutnCycleCd = [
        { label: "L_EVERYDAY", value: "A" },
        { label: "L_EVERY_WEEK", value: "B" },
        { label: "L_MONTHLY", value: "C" },
        { label: "L_EVERY_YEAR", value: "D" },
        { label: "L_PERIODIC", value: "E" },
    ];

    /* Batch Execution Day !== 일 ==!*/
    const btchExcutnDay = [
        { label: "1", value: "1" },
        { label: "2", value: "2" },
        { label: "3", value: "3" },
        { label: "4", value: "4" },
        { label: "5", value: "5" },
        { label: "6", value: "6" },
        { label: "7", value: "7" },
        { label: "8", value: "8" },
        { label: "9", value: "9" },
        { label: "10", value: "10" },
        { label: "11", value: "11" },
        { label: "12", value: "12" },
        { label: "13", value: "13" },
        { label: "14", value: "14" },
        { label: "15", value: "15" },
        { label: "16", value: "16" },
        { label: "17", value: "17" },
        { label: "18", value: "18" },
        { label: "19", value: "19" },
        { label: "20", value: "20" },
        { label: "21", value: "21" },
        { label: "22", value: "22" },
        { label: "23", value: "23" },
        { label: "24", value: "24" },
        { label: "25", value: "25" },
        { label: "26", value: "26" },
        { label: "27", value: "27" },
        { label: "28", value: "28" },
        { label: "29", value: "29" },
        { label: "30", value: "30" },
        { label: "31", value: "31" },
    ];

    /* Batch Execution Month !== 월 ==!*/
    const btchExcutnMm = [
        { label: "1", value: "01" },
        { label: "2", value: "02" },
        { label: "3", value: "03" },
        { label: "4", value: "04" },
        { label: "5", value: "05" },
        { label: "6", value: "06" },
        { label: "7", value: "07" },
        { label: "8", value: "08" },
        { label: "9", value: "09" },
        { label: "10", value: "10" },
        { label: "11", value: "11" },
        { label: "12", value: "12" },
    ];

    /* Batch Execution Time Minute Second !== 시간 분 초 ==!*/
    const btchExcutnTms = [
        { label: "L_HOUR", value: "T" },
        { label: "L_MI", value: "M" },
        { label: "L_SS", value: "S" },
    ];

    /*
     * Declaration Fetch
     * !== Fetch 정의 ==!
     */
    const fetch = {
        getBtchSchdInfo: useFetch({
            api: () => APIS.getBtchSchdInfo(btchSchdId),
            onSuccess: (data: any) => {
                const schdInfo = data.schdInfo.content;
                const schdPrmtList = schdInfo.schdPrmtList;

                setBtchCycleTp(schdInfo.excutnCycle);

                // Weekly checkbox settings !== 매주 체크박스 세팅 ==!
                if (schdInfo.excutnCycle === "B") {
                    const arrDmk = [];

                    if (schdInfo.excutnSchdDd[0] === "1") {
                        arrDmk.push("SUN");
                    }
                    if (schdInfo.excutnSchdDd[1] === "1") {
                        arrDmk.push("MON");
                    }
                    if (schdInfo.excutnSchdDd[2] === "1") {
                        arrDmk.push("TUE");
                    }
                    if (schdInfo.excutnSchdDd[3] === "1") {
                        arrDmk.push("WED");
                    }
                    if (schdInfo.excutnSchdDd[4] === "1") {
                        arrDmk.push("THU");
                    }
                    if (schdInfo.excutnSchdDd[5] === "1") {
                        arrDmk.push("FRI");
                    }
                    if (schdInfo.excutnSchdDd[6] === "1") {
                        arrDmk.push("SAT");
                    }

                    form.btchInfoForm.setValue("btchExcutnDwk", arrDmk);
                }
                // Monthly !== 매월 ==!
                else if (schdInfo.excutnCycle === "C") {
                    form.btchInfoForm.setValue("btchExcutnDay", schdInfo.excutnSchdDd.substring(6, 8));
                }
                // every year !== 매년 ==!
                else if (schdInfo.excutnCycle === "D") {
                    form.btchInfoForm.setValue("btchExcutnMm", schdInfo.excutnSchdDd.substring(4, 6));
                    form.btchInfoForm.setValue("btchExcutnDay", schdInfo.excutnSchdDd.substring(6, 8));
                }
                // periodic !== 주기적 ==!
                else if (schdInfo.excutnCycle === "E") {
                    if (schdInfo.excutnSchdTime !== "0" && schdInfo.excutnSchdTime !== "*") {
                        form.btchInfoForm.setValue("btchExcutnTms", ["T"]);
                        form.btchInfoForm.setValue("btchSchdTmsValue", schdInfo.excutnSchdTime);
                    } else if (schdInfo.excutnSchdMi !== "0" && schdInfo.excutnSchdMi !== "*") {
                        form.btchInfoForm.setValue("btchExcutnTms", ["M"]);
                        form.btchInfoForm.setValue("btchSchdTmsValue", schdInfo.excutnSchdMi);
                    } else if (schdInfo.excutnSchdSs !== "0" && schdInfo.excutnSchdSs !== "*") {
                        form.btchInfoForm.setValue("btchExcutnTms", ["S"]);
                        form.btchInfoForm.setValue("btchSchdTmsValue", schdInfo.excutnSchdSs);
                    }
                }

                form.btchInfoForm.setValues(schdInfo);

                /**
                 * Delete schedule parameter values
                 * - On the server, delete the existing schedule parameters and register them again.
                 * !==
                 * 스케줄 파라미터 값 제거
                 * - 서버에서는 기존 스케줄 파라미터를 삭제하고 다시 등록한다.
                 * ==!
                 */
                schdPrmtList.forEach((item: any) => {
                    item.btchPrmtValue = null;
                });

                grid.btchSchdPrmtList.setData(comnUtils.getGridData(schdPrmtList));
            },
            onError: (error) => {
                if (error.response.status === 400) {
                    const { errorMessage } = error.response.data;

                    modal.openModal({
                        content: errorMessage.content,
                        onConfirm: () => {
                            navigate(URLS.osci0112005q);
                        },
                        close: false,
                    });

                    return;
                }

                toast.showToast({ type: "error", content: "msg.osc.00035" }); // An error occurred. !== 에러가 발생했습니다! ==!
            },
        }),

        updateBtchSchdInfo: useFetch({
            api: (info: any) => APIS.updateBtchSchdInfo(info),
            enabled: false,
            onSuccess: () => {
                modal.openModal({
                    content: "msg.osc.00070", // Successfully updated. !== 정상적으로 수정되었습니다.==!
                    onConfirm: () => {
                        navigate(`${URLS.osci0112008q}/${btchSchdId}`);
                    },
                    close: false,
                });
            },
            onError: () => toast.showToast({ type: "error", content: "msg.osc.00039" }), // Failed to update. !== 수정이 실패하였습니다.==!
        }),

        deleteBtchSchdInfo: useFetch({
            api: (info: any) => APIS.deleteBtchSchdInfo(info),
            onSuccess: () => {
                modal.openModal({ content: "msg.osc.00071" }); // Successfully removed. !== 정상적으로 삭제되었습니다. ==!
                navigate(URLS.osci0112005q);
            },
            onError: () => toast.showToast({ type: "error", content: "msg.osc.00040" }), // Failed to remove. !== 삭제가 실패하였습니다. ==!
        }),
    };

    /*
     * Declaration Event Handler
     * !== 이벤트 핸들러 정의 ==!
     */
    const handler = {
        clickBtnDeleteGridList: () => {
            const seltList: any[] = grid.btchSchdPrmtList.getChecked() || [];
            if (comnUtils.isEmpty(seltList)) {
                modal.openModal({ content: "msg.osc.00009" });
                return;
            }

            grid.btchSchdPrmtList.deleteRow("checkbox");
        },

        onUpdateBtnClick: form.btchInfoForm.handleSubmit(
            () => {
                const data = form.btchInfoForm.getValues();

                if (data.excutnCycle == "B") {
                    const arrDay = [0, 0, 0, 0, 0, 0, 0];

                    for (let i = 0; i < data.btchExcutnDwk.length; i++) {
                        if (data.btchExcutnDwk[i] == "SUN") {
                            arrDay[0] = 1;
                        } else if (data.btchExcutnDwk[i] == "MON") {
                            arrDay[1] = 1;
                        } else if (data.btchExcutnDwk[i] == "TUE") {
                            arrDay[2] = 1;
                        } else if (data.btchExcutnDwk[i] == "WED") {
                            arrDay[3] = 1;
                        } else if (data.btchExcutnDwk[i] == "THU") {
                            arrDay[4] = 1;
                        } else if (data.btchExcutnDwk[i] == "FRI") {
                            arrDay[5] = 1;
                        } else if (data.btchExcutnDwk[i] == "SAT") {
                            arrDay[6] = 1;
                        }
                    }

                    data.excutnSchdDd = arrDay.join().replaceAll(",", "");
                } else if (data.excutnCycle == "C") {
                    data.excutnSchdDd = "000000" + data.btchExcutnDay;
                } else if (data.excutnCycle == "D") {
                    data.excutnSchdDd = "0000" + data.btchExcutnMm + data.btchExcutnDay;
                } else if (data.excutnCycle == "E") {
                    if (data.btchExcutnTms == "T") {
                        data.excutnSchdTime = data.btchSchdTmsValue;
                        data.excutnSchdMi = null;
                        data.excutnSchdSs = null;
                    }

                    if (data.btchExcutnTms == "M") {
                        data.excutnSchdTime = null;
                        data.excutnSchdMi = data.btchSchdTmsValue;
                        data.excutnSchdSs = null;
                    }

                    if (data.btchExcutnTms == "S") {
                        data.excutnSchdTime = null;
                        data.excutnSchdMi = null;
                        data.excutnSchdSs = data.btchSchdTmsValue;
                    }
                }

                data.schdPrmtList = grid.btchSchdPrmtList.getData();

                modal.openModal({
                    content: "msg.osc.00064", // Confirm update? !== 수정하시겠습니까? ==!
                    onConfirm: () => fetch.updateBtchSchdInfo.fetch(data),
                });
            },
            () => toast.showToast({ type: "warning", content: "msg.osc.00003" }), // Data is invalid, !== 데이터가 유효하지않습니다. ==!
        ),

        onDeleteBtnClick: () => {
            modal.openModal({
                content: "msg.osc.00062", // Confirm remove? !== 삭제하시겠습니까? ==!
                onConfirm: () => fetch.deleteBtchSchdInfo.fetch(form.btchInfoForm.getValue("btchSchdId")),
            });
        },
    };

    /*
     * Declaration Event Render
     * !== 랜더 정의 ==!
     */
    const render = {};

    /*
     * Page Init Function
     * !== 화면 초기화 함수 선언  ==!
     */
    useEffect(() => {
        fetch.getBtchSchdInfo.fetch();

        form.btchInfoForm.setEditable("btchId", false);
        form.btchInfoForm.setEditable("btchNm", false);
        form.btchInfoForm.setEditable("btchSchdId", false);

        // Setting batch parameters grid query version !== 배치 파라미터 그리드 조회 버전으로 세팅 ==!
        grid.btchSchdPrmtList.setEdit("column", "btchPrmtNm", false);
        grid.btchSchdPrmtList.setOption("checkbox", false);
        grid.btchSchdPrmtList.setOption("index", true);
    }, []);

    return (
        <Page>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.btchInfoForm.schema.btchId} controlSize={10} required={false} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.btchInfoForm.schema.btchNm} controlSize={10} required={false} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.btchInfoForm.schema.btchSchdId} controlSize={10} required={false} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.btchInfoForm.schema.btchSchdNm} controlSize={10} required={false} />
                        </Group.Row>

                        <Group.Row>
                            <Group.Label label={"L_EXCUTN_CYCLE"} required={true} />
                            <Group.Col padding={1} colSize={2}>
                                <FormControl
                                    {...form.btchInfoForm.schema.excutnCycle}
                                    options={excutnCycleCd}
                                    onChange={(value) => {
                                        setBtchCycleTp(value);
                                    }}
                                />
                            </Group.Col>

                            {btchCycleTp == "A" && (
                                <Group.Col padding={1} colSize={8}>
                                    <Group.Label label={"L_HOUR"} />
                                    <FormControl
                                        {...form.btchInfoForm.schema.excutnSchdTime}
                                        options={excutnSchdTime}
                                        size={2}
                                        required={true}
                                    />
                                    <Group.Label label={"L_MI"} />
                                    <FormControl
                                        {...form.btchInfoForm.schema.excutnSchdMi}
                                        options={excutnSchdMi}
                                        size={2}
                                        required={true}
                                    />
                                    <Group.Label label={"L_SS"} />
                                    <FormControl
                                        {...form.btchInfoForm.schema.excutnSchdSs}
                                        options={excutnSchdSs}
                                        size={2}
                                        required={true}
                                    />
                                </Group.Col>
                            )}

                            {btchCycleTp == "B" && (
                                <Group.Col padding={1} colSize={8}>
                                    <FormControl
                                        {...form.btchInfoForm.schema.btchExcutnDwk}
                                        options={btchExcutnDwk}
                                        size={6}
                                        required={true}
                                    />
                                    <Group.Label label={"L_HOUR"} />
                                    <FormControl
                                        {...form.btchInfoForm.schema.excutnSchdTime}
                                        options={excutnSchdTime}
                                        size={2}
                                        required={true}
                                    />
                                    <Group.Label label={"L_MI"} />
                                    <FormControl
                                        {...form.btchInfoForm.schema.excutnSchdMi}
                                        options={excutnSchdMi}
                                        size={2}
                                        required={true}
                                    />
                                    <Group.Label label={"L_SS"} />
                                    <FormControl
                                        {...form.btchInfoForm.schema.excutnSchdSs}
                                        options={excutnSchdSs}
                                        size={2}
                                        required={true}
                                    />
                                </Group.Col>
                            )}

                            {btchCycleTp == "C" && (
                                <Group.Col padding={1} colSize={8}>
                                    <Group.Label label={"L_DD"} />
                                    <FormControl
                                        {...form.btchInfoForm.schema.btchExcutnDay}
                                        options={btchExcutnDay}
                                        size={2}
                                        required={true}
                                    />
                                    <Group.Label label={"L_HOUR"} />
                                    <FormControl
                                        {...form.btchInfoForm.schema.excutnSchdTime}
                                        options={excutnSchdTime}
                                        size={2}
                                        required={true}
                                    />
                                    <Group.Label label={"L_MI"} />
                                    <FormControl
                                        {...form.btchInfoForm.schema.excutnSchdMi}
                                        options={excutnSchdMi}
                                        size={2}
                                        required={true}
                                    />
                                    <Group.Label label={"L_SS"} />
                                    <FormControl
                                        {...form.btchInfoForm.schema.excutnSchdSs}
                                        options={excutnSchdSs}
                                        size={2}
                                        required={true}
                                    />
                                </Group.Col>
                            )}

                            {btchCycleTp == "D" && (
                                <Group.Col padding={1} colSize={8}>
                                    <Group.Label label={"L_MM"} />
                                    <FormControl
                                        {...form.btchInfoForm.schema.btchExcutnMm}
                                        options={btchExcutnMm}
                                        size={2}
                                        required={true}
                                    />
                                    <Group.Label label={"L_DD"} />
                                    <FormControl
                                        {...form.btchInfoForm.schema.btchExcutnDay}
                                        options={btchExcutnDay}
                                        size={2}
                                        required={true}
                                    />
                                    <Group.Label label={"L_HOUR"} />
                                    <FormControl
                                        {...form.btchInfoForm.schema.excutnSchdTime}
                                        options={excutnSchdTime}
                                        size={2}
                                        required={true}
                                    />
                                    <Group.Label label={"L_MI"} />
                                    <FormControl
                                        {...form.btchInfoForm.schema.excutnSchdMi}
                                        options={excutnSchdMi}
                                        size={2}
                                        required={true}
                                    />
                                    <Group.Label label={"L_SS"} />
                                    <FormControl
                                        {...form.btchInfoForm.schema.excutnSchdSs}
                                        options={excutnSchdSs}
                                        size={2}
                                        required={true}
                                    />
                                </Group.Col>
                            )}

                            {btchCycleTp == "E" && (
                                <Group.Col padding={1} colSize={8}>
                                    <FormControl
                                        {...form.btchInfoForm.schema.btchExcutnTms}
                                        options={btchExcutnTms}
                                        size={2}
                                        required={true}
                                    />
                                    <FormControl
                                        {...form.btchInfoForm.schema.btchSchdTmsValue}
                                        size={2}
                                        maxLength={2}
                                        required={true}
                                    />
                                </Group.Col>
                            )}
                        </Group.Row>
                    </Group.Section>
                </Group.Body>
            </Group>

            {/* <Group>
                <Group.Body>
                    <Layout>
                        <Layout.Left>
                            <Group.Title title={"T_SCHD_PRMT_LIST"} titleSize={2}></Group.Title>
                        </Layout.Left>
                    </Layout>
                    <Group.Section>
                        <Grid {...grid.btchSchdPrmtList.grid} />
                    </Group.Section>
                </Group.Body>
            </Group> */}

            <Layout direction="row">
                <Layout.Left>
                    <Button
                        variant="secondary"
                        onClick={() => {
                            navigate(`${URLS.osci0112008q}/${btchSchdId}`);
                        }}
                    >
                        {t("B_PRE")}
                    </Button>
                    <Button
                        role="list"
                        onClick={() => {
                            navigate(URLS.osci0112005q);
                        }}
                    />
                </Layout.Left>
                <Layout.Right>
                    <Layout.Button role={"save"} onClick={handler.onUpdateBtnClick} />
                </Layout.Right>
            </Layout>
        </Page>
    );
};
